/** C 端登录后若依可能写入 teri_token 或 dj_token，取其一用于 Authorization */
export function getClientToken() {
    return localStorage.getItem("teri_token") || localStorage.getItem("dj_token") || "";
}

export function getClientBearer() {
    const t = getClientToken();
    return t ? "Bearer " + t : "";
}

/** Vuex 用户信息可能为 uid 或 userId（若依） */
export function getStoreViewerId(store) {
    const u = store && store.state ? store.state.user : null;
    if (!u || typeof u !== "object") {
        return null;
    }
    const id = u.uid != null ? u.uid : u.userId;
    if (id == null || id === "") {
        return null;
    }
    const n = Number(id);
    return Number.isFinite(n) && n > 0 ? n : null;
}

/** 登录后写入 localStorage 的 dj_user，新开标签页时 Vuex 可能尚未就绪 */
export function getCachedViewerId() {
    try {
        const raw = localStorage.getItem("dj_user");
        if (!raw || !String(raw).trim()) {
            return null;
        }
        const o = JSON.parse(raw);
        const id = o && (o.uid != null ? o.uid : o.userId);
        if (id == null || id === "") {
            return null;
        }
        const n = Number(id);
        return Number.isFinite(n) && n > 0 ? n : null;
    } catch {
        return null;
    }
}

/** 优先 Vuex，其次本地缓存（与顶栏收藏预览一致） */
export function resolveViewerId(store) {
    return getStoreViewerId(store) ?? getCachedViewerId();
}

/** 是否为制作人角色（sys_role.role_id = 2） */
export function isProducerUser(store) {
    const fromStore = store && store.state && store.state.user;
    if (fromStore && fromStore.isProducer === true) {
        return true;
    }
    try {
        const raw = localStorage.getItem('dj_user');
        if (!raw || !String(raw).trim()) {
            return false;
        }
        const u = JSON.parse(raw);
        return u && u.isProducer === true;
    } catch {
        return false;
    }
}
